export default function orderProductTags(tags, sequence = []) {
  const positions = new Map((Array.isArray(sequence) ? sequence : []).map((tag, index) => [String(tag).trim().toLowerCase(), index]));
  const rank = tag => positions.get(String(tag).trim().toLowerCase()) ?? Number.MAX_SAFE_INTEGER;
  return [...tags].sort((left, right) => rank(left) - rank(right));
}
